import {
  ISocialPageGroupSetQuery,
  SocialPageGroupSetDocument,
  useSocialPageGroupSetQuery,
} from "@smp/graphql";
import { useQueryClient } from "react-query";

import { gqlClient } from "@/hooks/use_graphql";

export const useFetchSocialPageGroup = () => {
  const queryClient = useQueryClient();

  return async (id: number) => {
    const result = await queryClient.fetchQuery<ISocialPageGroupSetQuery>({
      queryKey: useSocialPageGroupSetQuery.getKey({
        id__in: [id],
      }),

      queryFn: () =>
        gqlClient.request(SocialPageGroupSetDocument, {
          id__in: [id],
        }),

      staleTime: 0,
    });

    return result.social_page_group_set.at(0);
  };
};
